/* Caddie for Zanetta Sg: collection page (v1.2.0). Loaded only by the collection section.
   The theme's OWN filtering: no Search and Discovery filters needed. The section renders every card
   (up to 250 a page) and a JSON block of variant data; this file filters, counts and sorts them in the
   browser. A product matches when ONE variant meets every chosen size, colour, stock and price filter
   together, so "In stock in my size" never shows a style whose size exists but is sold out.
   State lives in the URL (size, colour, stock, min, max, sort_by): shareable, and back/forward work.
   Without this file the grid shows every product and the sort form submits as a plain GET.
   v1.11.0 (layout B): the filter panel is a drawer at every width; the size row is gone (the Size filter is the one size
   picker and remembers a single chosen size); size runs: the main run first, others after, unlabelled; a filter group
   with only one value on the collection is left out. */
(function () {
  'use strict';
  function boot() {
    var Z = window.ZT; if (!Z) return;
    var $ = Z.$, $$ = Z.$$, fill = Z.fill, esc = Z.esc;
    var root = $('[data-plp]'); if (!root || root._plp) return; root._plp = true;
    var sid = root.getAttribute('data-section'), base = root.getAttribute('data-url');
    var perPage = parseInt(root.getAttribute('data-per-page'), 10) || 24;
    var total = parseInt(root.getAttribute('data-total'), 10) || 0;
    var serverSort = root.getAttribute('data-sort') || 'manual';
    var defaultSort = root.getAttribute('data-default-sort') || serverSort;
    var L = {}; try { L = JSON.parse($('[data-plp-strings]', root).textContent); } catch (e) {}
    var grid = $('[data-plp-grid]', root);
    var drawer = document.getElementById('Filters-' + sid);
    var form = $('[data-filter-form]', root), facetsEl = $('[data-plp-facets]', root);
    var sortSel = $('[data-plp-sort]', root);
    var P = [], byId = {}, orders = {}, limit = perPage, timer = null;
    var KEYS = ['size', 'colour', 'stock', 'min', 'max'];

    function done() { document.documentElement.classList.remove('plp-pending'); }
    if (!grid) { done(); return; }

    /* ---------- the filter panel is a dialog (a drawer) at every width ---------- */
    if (drawer) { drawer.setAttribute('role', 'dialog'); drawer.setAttribute('aria-modal', 'true'); }

    /* ---------- colour names: trim, fold case, then the editable map from the section settings ---------- */
    function fold(s) { return String(s == null ? '' : s).trim().replace(/\s+/g, ' ').toLowerCase(); }
    var MAP = {}, MAP_LABEL = {};
    String(L.colour_map || '').split(/\r?\n/).forEach(function (line) {
      var m = line.split('='); if (m.length < 2) return;
      var from = fold(m[0]), to = m.slice(1).join('=').trim();
      if (from && to) { MAP[from] = fold(to); MAP_LABEL[fold(to)] = to; }
    });
    function ckey(raw) { var k = fold(raw); return MAP[k] || k; }

    /* ---------- money, from the store's own format (Liquid printed 100 cents for us) ---------- */
    function money(c) {
      var sample = L.money || '', n = (c / 100).toFixed(2);
      var m = sample.match(/1([.,])00/);
      if (m) return sample.replace(m[0], n.replace('.', m[1]));
      return sample.replace('1', String(Math.round(c / 100)));
    }
    function plural(key, n) { return fill(n === 1 ? L[key + '_one'] : L[key + '_other'], { count: n }); }

    /* ---------- data ---------- */
    function ingest(scope) {
      $$('[data-plp-data]', scope).forEach(function (s) {
        var arr = []; try { arr = JSON.parse(s.textContent); } catch (e) {}
        arr.forEach(function (p) {
          if (byId[p.id]) return;
          p.el = grid.querySelector('[data-pid="' + p.id + '"]'); if (!p.el) return;
          p.i = P.length;
          p.min = Math.min.apply(null, p.v.map(function (v) { return v[3]; }));
          p.time = Date.parse(p.d) || 0;
          p.v.forEach(function (v) { v[5] = v[1] == null ? null : ckey(v[1]); });
          P.push(p); byId[p.id] = p;
        });
        if (s.parentNode && scope !== document) s.parentNode.removeChild(s);
      });
    }
    ingest(root);
    orders[serverSort] = P.map(function (p) { return p.id; });

    /* ---------- facet values, from every loaded product ---------- */
    var SIZES = [], SIZE_GROUPS = [], COLOURS = [], COLOUR_LABEL = {}, PRICE_MAX = 0, PRICE_MIN = 0, ALL_AVAIL = true;
    function num(s) { var n = parseFloat(s); return isNaN(n) ? null : n; }
    function buildValues() {
      var sizes = {}, colours = {}, rawCount = {};
      PRICE_MAX = 0; PRICE_MIN = Infinity; ALL_AVAIL = true;
      P.forEach(function (p) {
        p.v.forEach(function (v) {
          if (v[0] != null && v[0] !== '') sizes[v[0]] = true;
          if (v[5]) { colours[v[5]] = true; rawCount[v[5] + '\u0001' + v[1].trim()] = (rawCount[v[5] + '\u0001' + v[1].trim()] || 0) + 1; }
          if (v[3] > PRICE_MAX) PRICE_MAX = v[3];
          if (v[3] < PRICE_MIN) PRICE_MIN = v[3];
          if (!v[2]) ALL_AVAIL = false;
        });
      });
      SIZES = Object.keys(sizes).sort(function (a, b) {
        var x = num(a), y = num(b);
        if (x != null && y != null) return x - y;
        if (x != null) return -1; if (y != null) return 1;
        return a.localeCompare(b);
      });
      /* separate runs where the numbers jump (4 to 11 and 30 to 45 are different size systems) */
      SIZE_GROUPS = [];
      SIZES.forEach(function (s) {
        var g = SIZE_GROUPS[SIZE_GROUPS.length - 1], n = num(s), last = g && g[g.length - 1];
        var jump = !g || (n == null) !== (num(last) == null) || (n != null && n - num(last) > 5);
        if (jump) SIZE_GROUPS.push([s]); else g.push(s);
      });
      /* the main size run first (the longest), any other run after it */
      SIZE_GROUPS = SIZE_GROUPS.map(function (g, i) { return { g: g, i: i }; }).sort(function (a, b) { return b.g.length - a.g.length || a.i - b.i; }).map(function (x) { return x.g; });
      COLOURS = Object.keys(colours);
      COLOUR_LABEL = {};
      COLOURS.forEach(function (k) {
        if (MAP_LABEL[k]) { COLOUR_LABEL[k] = MAP_LABEL[k]; return; }
        var best = null, bestN = -1;
        Object.keys(rawCount).forEach(function (rk) {
          var parts = rk.split('\u0001'); if (parts[0] !== k) return;
          if (rawCount[rk] > bestN) { best = parts[1]; bestN = rawCount[rk]; }
        });
        COLOUR_LABEL[k] = best || k;
      });
      COLOURS.sort(function (a, b) { return COLOUR_LABEL[a].localeCompare(COLOUR_LABEL[b]); });
    }
    buildValues();

    /* ---------- state <-> URL ---------- */
    function readURL() {
      var q = new URLSearchParams(location.search);
      var toCents = function (x) { var n = parseFloat(x); return isNaN(n) || n < 0 ? null : Math.round(n * 100); };
      return {
        size: q.getAll('size').filter(Boolean),
        colour: q.getAll('colour').map(fold).filter(Boolean),
        stock: q.get('stock') === '1',
        min: toCents(q.get('min')), max: toCents(q.get('max')),
        sort: q.get('sort_by') || defaultSort
      };
    }
    function query(st) {
      var q = new URLSearchParams(location.search);
      KEYS.forEach(function (k) { q.delete(k); });
      q.delete('sort_by'); q.delete('page'); q.delete('section_id');
      st.size.forEach(function (s) { q.append('size', s); });
      st.colour.forEach(function (c) { q.append('colour', c); });
      if (st.stock) q.append('stock', '1');
      if (st.min != null) q.append('min', String(st.min / 100));
      if (st.max != null) q.append('max', String(st.max / 100));
      if (st.sort && st.sort !== defaultSort) q.append('sort_by', st.sort);
      return q.toString();
    }
    function push(st) {
      var s = query(st), u = base + (s ? '?' + s : '');
      if (u !== location.pathname + location.search && history.pushState) history.pushState({ plp: 1 }, '', u);
    }
    var state = readURL();

    /* ---------- matching ---------- */
    function variantOk(p, v, st, skip) {
      if (skip !== 'size' && st.size.length && (p.si < 0 || st.size.indexOf(v[0]) < 0)) return false;
      if (skip !== 'colour' && st.colour.length && (p.ci < 0 || st.colour.indexOf(v[5]) < 0)) return false;
      if (skip !== 'stock' && st.stock && !v[2]) return false;
      if (skip !== 'price') {
        if (st.min != null && v[3] < st.min) return false;
        if (st.max != null && v[3] > st.max) return false;
      }
      return true;
    }
    function matches(p, st, skip, extra) {
      return p.v.some(function (v) { return variantOk(p, v, st, skip) && (!extra || extra(v)); });
    }
    function countWhere(skip, extra) {
      var n = 0; P.forEach(function (p) { if (matches(p, state, skip, extra)) n++; }); return n;
    }

    /* ---------- sort ---------- */
    function sortList(list, key) {
      var cmp;
      var ord = orders[key];
      if (key === 'price-ascending') cmp = function (a, b) { return a.min - b.min; };
      else if (key === 'price-descending') cmp = function (a, b) { return b.min - a.min; };
      else if (key === 'title-ascending') cmp = function (a, b) { return a.t.localeCompare(b.t); };
      else if (key === 'title-descending') cmp = function (a, b) { return b.t.localeCompare(a.t); };
      else if (key === 'created-ascending') cmp = function (a, b) { return a.time - b.time; };
      else if (key === 'created-descending') cmp = function (a, b) { return b.time - a.time; };
      else if (ord) {
        var at = {}; ord.forEach(function (id, n) { at[id] = n; });
        cmp = function (a, b) { return (a.id in at ? at[a.id] : 1e6 + a.i) - (b.id in at ? at[b.id] : 1e6 + b.i); };
      }
      return list.slice().sort(function (a, b) { return (cmp ? cmp(a, b) : 0) || a.i - b.i; });
    }
    var LOCAL_SORTS = /^(price|title|created)-/;
    /* Featured and Best selling only Shopify knows: fetch that order once (the same section, ids only) */
    function ensureOrder(key) {
      if (orders[key] || LOCAL_SORTS.test(key)) return Promise.resolve();
      return fetch(base + '?sort_by=' + encodeURIComponent(key) + '&section_id=' + encodeURIComponent(sid))
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html'), s = doc.querySelector('[data-plp-data]');
          var arr = []; try { arr = JSON.parse(s.textContent); } catch (e) {}
          orders[key] = arr.map(function (p) { return p.id; });
        })
        .catch(function () { orders[key] = orders[serverSort]; });
    }

    /* ---------- facets (built once, then updated in place so focus never jumps) ---------- */
    function fv(id, name, value, label, counted) {
      return '<span class="fv"><input type="checkbox" id="' + id + '" name="' + name + '" value="' + esc(value) + '">' +
        '<label for="' + id + '"><span class="fv-l">' + esc(label) + '</span>' +
        (counted ? '<span class="fv-n" data-n></span>' : '<span class="sr" data-n></span>') + '</label></span>';
    }
    function buildFacets() {
      if (!facetsEl) return;
      var open = {}; $$('details', facetsEl).forEach(function (d) { open[d.id] = d.open; });
      var h = '', pre = 'F-' + sid + '-';
      /* a filter group with only one value on this collection is left out */
      if (SIZES.length > 1) {
        h += '<details id="FG-' + sid + '-size" class="fg" open><summary><span>' + esc(L.size) + '</span><span class="fg-n" data-fg-n="size" hidden></span></summary>' +
          '<fieldset class="fg-body"><legend class="sr">' + esc(L.size) + '</legend>';
        SIZE_GROUPS.forEach(function (g, gi) {
          h += '<div class="fg-size' + (gi > 0 ? ' fg-size--minor' : '') + '" role="group" aria-label="' + esc(L.size) + '">';
          g.forEach(function (s) { h += fv(pre + 'size-' + SIZES.indexOf(s), 'size', s, s, false); });
          h += '</div>';
        });
        h += '</fieldset></details>';
      }
      if (COLOURS.length > 1) {
        h += '<details id="FG-' + sid + '-colour" class="fg" open><summary><span>' + esc(L.colour) + '</span><span class="fg-n" data-fg-n="colour" hidden></span></summary>' +
          '<fieldset class="fg-body fg-colour"><legend class="sr">' + esc(L.colour) + '</legend>';
        COLOURS.forEach(function (k, n) { h += fv(pre + 'colour-' + n, 'colour', k, COLOUR_LABEL[k], true); });
        h += '</fieldset></details>';
      }
      if (!ALL_AVAIL) h += '<details id="FG-' + sid + '-stock" class="fg" open><summary><span>' + esc(L.availability) + '</span><span class="fg-n" data-fg-n="stock" hidden></span></summary>' +
        '<fieldset class="fg-body"><legend class="sr">' + esc(L.availability) + '</legend>' + fv(pre + 'stock', 'stock', '1', L.in_stock, true) + '</fieldset></details>';
      var maxD = Math.ceil(PRICE_MAX / 100);
      if (PRICE_MIN !== PRICE_MAX) h += '<details id="FG-' + sid + '-price" class="fg"><summary><span>' + esc(L.price) + '</span><span class="fg-n" data-fg-n="price" hidden></span></summary>' +
        '<fieldset class="fg-body"><legend class="sr">' + esc(L.price) + '</legend><div class="price-row">' +
        '<div class="field"><label for="' + pre + 'min">' + esc(L.from) + '</label><input id="' + pre + 'min" type="number" inputmode="decimal" min="0" step="any" name="min" placeholder="0" data-price-input></div>' +
        '<div class="field"><label for="' + pre + 'max">' + esc(L.to) + '</label><input id="' + pre + 'max" type="number" inputmode="decimal" min="0" step="any" name="max" placeholder="' + maxD + '" data-price-input></div>' +
        '</div><p class="note">' + esc(fill(L.price_max, { price: money(PRICE_MAX) })) + '</p></fieldset></details>';
      var focusId = document.activeElement && facetsEl.contains(document.activeElement) ? document.activeElement.id : null;
      facetsEl.innerHTML = h;
      Object.keys(open).forEach(function (id) { var d = document.getElementById(id); if (d) d.open = open[id]; });
      if (focusId) { var f = document.getElementById(focusId); if (f) f.focus({ preventScroll: true }); }
    }
    function syncForm() {
      if (!facetsEl) return;
      $$('input[name="size"]', facetsEl).forEach(function (i) { i.checked = state.size.indexOf(i.value) > -1; });
      $$('input[name="colour"]', facetsEl).forEach(function (i) { i.checked = state.colour.indexOf(i.value) > -1; });
      var st = $('input[name="stock"]', facetsEl); if (st) st.checked = state.stock;
      var mn = $('input[name="min"]', facetsEl), mx = $('input[name="max"]', facetsEl);
      if (mn && document.activeElement !== mn) mn.value = state.min != null ? String(state.min / 100) : '';
      if (mx && document.activeElement !== mx) mx.value = state.max != null ? String(state.max / 100) : '';
      if (state.min != null || state.max != null) { var d = document.getElementById('FG-' + sid + '-price'); if (d) d.open = true; }
      if (sortSel) sortSel.value = state.sort;
    }
    function fromForm() {
      var toCents = function (i) { if (!i || i.value.trim() === '') return null; var n = parseFloat(i.value); return isNaN(n) || n < 0 ? null : Math.round(n * 100); };
      return {
        size: $$('input[name="size"]:checked', facetsEl).map(function (i) { return i.value; }),
        colour: $$('input[name="colour"]:checked', facetsEl).map(function (i) { return i.value; }),
        stock: !!$('input[name="stock"]:checked', facetsEl),
        min: toCents($('input[name="min"]', facetsEl)), max: toCents($('input[name="max"]', facetsEl)),
        sort: state.sort
      };
    }
    function updateFacets() {
      if (!facetsEl) return;
      $$('input[name="size"]', facetsEl).forEach(function (i) {
        var x = i.value, n = countWhere('size', function (v) { return v[0] === x; });
        setN(i, n);
      });
      $$('input[name="colour"]', facetsEl).forEach(function (i) {
        var x = i.value, n = countWhere('colour', function (v) { return v[5] === x; });
        setN(i, n);
      });
      var st = $('input[name="stock"]', facetsEl);
      if (st) setN(st, countWhere('stock', function (v) { return !!v[2]; }));
      var act = { size: state.size.length, colour: state.colour.length, stock: state.stock ? 1 : 0, price: (state.min != null || state.max != null) ? 1 : 0 };
      $$('[data-fg-n]', facetsEl).forEach(function (b) { var n = act[b.getAttribute('data-fg-n')]; b.textContent = n; b.hidden = !n; });
      /* the remembered size gets a small dot */
      var mineS = Z.Size && Z.Size.get();
      $$('input[name="size"]', facetsEl).forEach(function (i) { i.parentNode.classList.toggle('is-mine', i.value === mineS); });
    }
    function setN(input, n) {
      var lab = input.nextElementSibling, nEl = lab && $('[data-n]', lab);
      if (nEl) nEl.textContent = '(' + n + ')';
      var off = n === 0 && !input.checked;
      input.disabled = off;
      input.parentNode.classList.toggle('is-off', off);
    }

    /* ---------- active filter chips ---------- */
    var activeEl = $('[data-plp-active]', root);
    function activeList() {
      var a = [];
      state.size.forEach(function (s) { a.push({ k: 'size', v: s, l: fill(L.size_chip, { size: s }) }); });
      state.colour.forEach(function (c) { a.push({ k: 'colour', v: c, l: COLOUR_LABEL[c] || c }); });
      if (state.stock) a.push({ k: 'stock', v: '1', l: L.in_stock });
      if (state.min != null || state.max != null) a.push({ k: 'price', v: '', l: fill(L.price_chip, { min: money(state.min || 0), max: money(state.max != null ? state.max : PRICE_MAX) }) });
      return a;
    }
    function renderActive(list) {
      if (!activeEl) return;
      activeEl.hidden = !list.length;
      activeEl.setAttribute('aria-label', plural('active', list.length));
      activeEl.innerHTML = list.map(function (f, n) {
        return '<li><button type="button" class="chip chip--x" data-remove="' + f.k + '" data-value="' + esc(f.v) + '" data-n="' + n + '">' + esc(f.l) +
          '<span aria-hidden="true"> &times;</span><span class="sr"> ' + esc(L.remove) + '</span></button></li>';
      }).join('') + (list.length ? '<li><button type="button" class="chip chip--clear" data-plp-clear>' + esc(L.clear_all) + '</button></li>' : '');
      var dot = $('[data-plp-active-count]', root);
      if (dot) { dot.hidden = !list.length; dot.innerHTML = list.length + '<span class="sr"> ' + esc(plural('active', list.length)) + '</span>'; }
    }

    /* ---------- card touches: colour photo, fit line ---------- */
    function swapImg(img, entry) {
      if (!img || !entry) return;
      var n = new Image(); n.sizes = img.sizes; n.srcset = entry.set; n.src = entry.src;
      var fin = function () { img.srcset = entry.set; img.src = entry.src; if (entry.alt) img.alt = entry.alt; };
      if (n.decode) n.decode().then(fin, fin); else fin();
    }
    function cardColour(p) {
      var img = $('.card-img-1', p.el), links = $$('[data-card-link]', p.el);
      var want = null;
      if (state.colour.length && p.ci > -1) {
        for (var n = 0; n < state.colour.length && !want; n++) {
          for (var raw in p.img) { if (ckey(raw) === state.colour[n]) { want = raw; break; } }
        }
      }
      if (want) {
        if (!p.orig && img) p.orig = { src: img.getAttribute('src'), set: img.getAttribute('srcset'), alt: img.alt, href: links.map(function (a) { return a.getAttribute('href'); }) };
        if (p.shown !== want) { swapImg(img, p.img[want]); p.shown = want; }
        var vs = p.v.filter(function (v) { return v[1] === want && variantOk(p, v, state, 'colour'); });
        var pick = vs.filter(function (v) { return v[2]; })[0] || vs[0];
        var href = p.orig ? p.orig.href[0] : (links[0] && links[0].getAttribute('href'));
        if (pick && href) links.forEach(function (a) { a.setAttribute('href', href.split('?')[0] + '?variant=' + pick[4]); });
        $$('.sw[data-sw]', p.el).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-sw') === want ? 'true' : 'false'); });
      } else if (p.orig && p.shown) {
        if (img) { if (p.orig.set) img.setAttribute('srcset', p.orig.set); img.setAttribute('src', p.orig.src); img.alt = p.orig.alt; }
        links.forEach(function (a, n) { a.setAttribute('href', p.orig.href[n]); });
        $$('.sw[data-sw]', p.el).forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        p.shown = null;
      }
    }
    function fitLines(list) {
      var one = state.size.length === 1 ? state.size[0] : null;
      if (!one) { P.forEach(function (p) { p.el.classList.remove('is-dim'); var f = $('[data-fit]', p.el); if (f) f.classList.remove('fit--no'); }); document.dispatchEvent(new CustomEvent('cards:added')); return; }
      list.forEach(function (p) {
        var fit = $('[data-fit]', p.el); if (!fit) return;
        var have = p.v.some(function (v) { return v[0] === one && v[2] && variantOk(p, v, state, 'stock'); });
        fit.textContent = fill(have ? (window.theme && window.theme.strings.in_your_size) : (window.theme && window.theme.strings.not_in_your_size), { size: one });
        fit.classList.toggle('fit--no', !have);
        p.el.classList.toggle('is-dim', !have);
      });
    }

    /* ---------- render ---------- */
    var countEl = $('[data-plp-count]', root), showBtn = $('[data-plp-show]', root);
    var emptyEl = $('[data-plp-empty]', root), moreBtn = $('[data-plp-showmore]', root), showingEl = $('[data-plp-showing]', root);
    var partialEl = $('[data-plp-partial]', root);
    function render(announce) {
      var list = sortList(P.filter(function (p) { return matches(p, state); }), state.sort);
      /* reorder only when the order changed */
      var cur = $$(':scope > li', grid), want = list.concat(P.filter(function (p) { return list.indexOf(p) < 0; }));
      var same = cur.length === want.length && want.every(function (p, n) { return cur[n] === p.el; });
      if (!same) { var frag = document.createDocumentFragment(); want.forEach(function (p) { frag.appendChild(p.el); }); grid.appendChild(frag); }
      var shown = Math.min(limit, list.length);
      P.forEach(function (p) { var k = list.indexOf(p); p.el.hidden = k < 0 || k >= limit; });
      grid.classList.add('is-live');
      list.slice(0, shown).forEach(cardColour);
      fitLines(list.slice(0, shown));

      var txt = plural('pairs', list.length);
      if (countEl) countEl.textContent = txt;
      if (showBtn) showBtn.textContent = plural('show', list.length);
      if (emptyEl) emptyEl.hidden = list.length > 0;
      if (moreBtn) moreBtn.hidden = shown >= list.length;
      if (showingEl) { showingEl.hidden = shown >= list.length; showingEl.textContent = fill(L.showing, { shown: shown, total: list.length }); }
      if (partialEl) partialEl.textContent = fill(L.partial, { loaded: P.length, total: total });
      renderActive(activeList());
      updateFacets();
      done();
      if (announce) Z.announce(txt);
      return list;
    }

    function apply(next, opts) {
      opts = opts || {};
      /* one chosen size is remembered (cards and product pages read it) */
      if (next.size.length === 1 && Z.Size && next.size[0] !== Z.Size.get()) Z.Size.set(next.size[0]);
      var sortChanged = next.sort !== state.sort;
      state = next;
      limit = perPage;
      if (!opts.noPush) push(state);
      var results = $('[data-plp-results]', root);
      if (sortChanged && !orders[state.sort] && !LOCAL_SORTS.test(state.sort)) {
        if (results) results.setAttribute('aria-busy', 'true');
        return ensureOrder(state.sort).then(function () { if (results) results.removeAttribute('aria-busy'); render(true); });
      }
      render(!opts.quiet);
      return Promise.resolve();
    }

    /* ---------- events ---------- */
    if (form) {
      form.addEventListener('change', function () { clearTimeout(timer); apply(fromForm()); });
      form.addEventListener('input', function (e) {
        if (!e.target.hasAttribute('data-price-input')) return;
        clearTimeout(timer);
        timer = setTimeout(function () { apply(fromForm()); }, 600);
      });
      form.addEventListener('submit', function (e) { e.preventDefault(); clearTimeout(timer); apply(fromForm()); });
    }
    if (sortSel) {
      var sortForm = sortSel.form;
      if (sortForm) sortForm.addEventListener('submit', function (e) { e.preventDefault(); });
      sortSel.addEventListener('change', function () {
        var next = Object.assign({}, state, { sort: sortSel.value });
        apply(next);
      });
    }
    function clearAll(focusAfter) {
      apply({ size: [], colour: [], stock: false, min: null, max: null, sort: state.sort }).then(function () {
        syncForm(); updateFacets();
        if (focusAfter) focusAfter();
      });
    }

    root.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-remove]');
      if (rm) {
        var k = rm.getAttribute('data-remove'), v = rm.getAttribute('data-value'), idx = +rm.getAttribute('data-n');
        var nx = Object.assign({}, state);
        if (k === 'size') nx.size = state.size.filter(function (x) { return x !== v; });
        if (k === 'colour') nx.colour = state.colour.filter(function (x) { return x !== v; });
        if (k === 'stock') nx.stock = false;
        if (k === 'price') { nx.min = null; nx.max = null; }
        apply(nx).then(function () {
          syncForm(); updateFacets();
          var chips = $$('[data-remove],.chip--clear', activeEl);
          var f = chips[Math.min(idx, chips.length - 1)];
          if (!f || !$$('[data-remove]', activeEl).length) f = document.getElementById('col-h');
          if (f) { if (f.id === 'col-h') f.setAttribute('tabindex', '-1'); f.focus({ preventScroll: true }); }
        });
        return;
      }
      var clr = e.target.closest('[data-plp-clear]');
      if (clr) {
        e.preventDefault();
        var inDrawer = drawer && drawer.contains(clr);
        clearAll(function () {
          if (inDrawer) { var t = $('.drawer-title', drawer); if (t) t.focus({ preventScroll: true }); }
          else { var h = document.getElementById('col-h'); h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); }
        });
        return;
      }
      if (e.target.closest('[data-plp-showmore]')) {
        var list = sortList(P.filter(function (p) { return matches(p, state); }), state.sort);
        var from = limit; limit += perPage;
        render(false);
        var first = list[from], a = first && $('h3 a', first.el);
        if (a) a.focus();
        Z.announce(showingEl && !showingEl.hidden ? showingEl.textContent : plural('pairs', list.length));
        return;
      }
      var nxt = e.target.closest('[data-plp-next]');
      if (nxt) {
        e.preventDefault();
        nxt.setAttribute('aria-busy', 'true'); nxt.textContent = ((window.theme && window.theme.strings.loading) || 'Loading') + '...';
        var nu = new URL(nxt.href, location.href); nu.searchParams.set('section_id', sid);
        fetch(nu.toString()).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var before = P.length;
          Array.prototype.forEach.call(doc.querySelectorAll('[data-plp-grid] > li'), function (li) {
            var id = li.getAttribute('data-pid'); if (byId[id]) return;
            var n = document.importNode(li, true); n.hidden = true; grid.appendChild(n);
          });
          ingest(doc);
          orders[serverSort] = (orders[serverSort] || []).concat(P.slice(before).map(function (p) { return p.id; }));
          var nn = doc.querySelector('[data-plp-next]');
          if (nn) { nxt.href = nn.getAttribute('href'); nxt.removeAttribute('aria-busy'); nxt.textContent = nn.textContent; }
          else { nxt.parentNode.removeChild(nxt); if (partialEl) { partialEl.parentNode.removeChild(partialEl); partialEl = null; } }
          buildValues(); buildFacets(); syncForm();
          limit = Math.max(limit, perPage) + perPage;
          render(false);
          document.dispatchEvent(new CustomEvent('cards:added'));
          var first = P[before], a = first && !first.el.hidden && $('h3 a', first.el);
          if (a) a.focus();
          Z.announce(plural('pairs', countWhere()));
        }).catch(function () { location.href = nxt.href; });
      }
    });

    window.addEventListener('popstate', function () {
      var next = readURL();
      apply(next, { noPush: true }).then(syncForm);
      syncForm();
    });
    document.addEventListener('size:change', function () { updateFacets(); });

    /* ---------- start ---------- */
    buildFacets();
    syncForm();
    if (partialEl) partialEl.textContent = fill(L.partial, { loaded: P.length, total: total });
    if (state.sort !== serverSort && !LOCAL_SORTS.test(state.sort)) ensureOrder(state.sort).then(function () { render(false); });
    else render(false);
  }
  if (window.ZT) boot(); else document.addEventListener('zt:ready', boot);
})();
